export default __webpack_public_path__ + "e437cec9566f660c1b2b599ab24453b2.png";